const MODEL_NAME = 'logout'
export default [
  {
    path: `/${MODEL_NAME}/index`,
    name: 'index',
    component: () => import(/* webpackChunkName: "logout-index" */ '@pages/logOut/index.vue')
  },
  {
    path: `/${MODEL_NAME}/protocol`,
    name: 'protocol',
    component: () => import(/* webpackChunkName: "logout-protocol" */ '@pages/logOut/protocol.vue')
  },
  {
    path: `/${MODEL_NAME}/phoneCheck`,
    name: 'phoneCheck',
    component: () =>
      import(/* webpackChunkName: "logout-phoneCheck" */ '@pages/logOut/phoneCheck.vue')
  },
  {
    path: `/${MODEL_NAME}/success`,
    name: 'success',
    component: () => import(/* webpackChunkName: "logout-success" */ '@pages/logOut/success.vue')
  },
  {
    path: `/${MODEL_NAME}/cancelFail`,
    name: 'cancelFail',
    component: () =>
      import(/* webpackChunkName: "logout-cancelFail" */ '@pages/logOut/cancelFail.vue')
  },
  {
    path: `/${MODEL_NAME}/reason`,
    name: 'reason',
    component: () => import(/* webpackChunkName: "logout-reason" */ '@pages/logOut/reason.vue')
  },
  {
    path: `/${MODEL_NAME}/loading`,
    name: 'loading',
    component: () => import(/* webpackChunkName: "logout-reason" */ '@pages/logOut/loading.vue')
  }
]
